import { render, staticRenderFns } from "./BadgeCard.vue?vue&type=template&id=ed29518c&"
import script from "./BadgeCard.vue?vue&type=script&lang=js&"
export * from "./BadgeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports